<template>
  <v-app id="izone_map">
    <SpaceDetails :space="getCurrentSpace" :clear="removeCurrentSpace"/>
    
    <v-navigation-drawer v-model="drawer" app dense>
      <v-select v-model="currentFloorId" :items="getFloors" label="Select floor" :menu-props="{ maxHeight: 404 }">
      </v-select>

      <v-list v-if="getCurrentFloor" dense>
        <v-list-item-group color="black">
          <v-list-item>
            <v-list-item-content @click.prevent="setCurrentSpace(null)">
              <v-list-item-title>All</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :key="space.id" v-for="space in getCurrentFloor.spaces" v-on:click.prevent="setCurrentSpace(space.id)">
            <v-list-item-content>
              <v-list-item-title v-text="space.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    
    <v-app-bar color="#9efcbd" app light dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
      <v-toolbar-title>IZONE Map</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon color="black" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.prevent="logOut">
            <v-list-item-title>Log out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <svg v-if="getCurrentFloor" id="map" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 478" width="100%">
        <defs>
          <filter id="shadow">
            <feDropShadow dx="0.2" dy="0.4" stdDeviation="0.5" flood-color="white"/>
          </filter>
        </defs>
        <image id="img1" :href="getCurrentFloor.plan" x="0" y="0" width="100%" height="100%"/>
        <g :key="space.id" v-for="space in getCurrentFloor.spaces">
          <rect v-on:click.prevent="setCurrentSpace(space.id)" :x="space.map_x" :y="space.map_y" :width="space.map_width" :height="space.map_height" :fill="getSpaceColor(space)" fill-opacity="0.5"/>
          <text v-if="space.latest_rent_history && space.latest_rent_history.tenant" :x="space.map_x + 5" :y="space.map_y + space.map_height - 20" style="font-size:8px; font-weight:bold; filter:url(#shadow); fill:black;">
            {{space.latest_rent_history.tenant.name}}
          </text>
          <text :x="space.map_x + 5" :y="space.map_y + space.map_height - 10" style="font-size:8px; font-weight:bold; filter:url(#shadow); fill:black;">
            {{space.total_square}} м²
          </text>
        </g>
      </svg>
    </v-content>
  </v-app>
</template>

<script>
import SpaceDetails from "@/components/SpaceDetails.vue";
export default {
  name: 'Map',
  components: {
    SpaceDetails
  },
  data() { 
    return {
      buildings: [],
      currentFloorId: localStorage.getItem('currentFloorId'),
      currentSpaceId: null,
      drawer: true,
    };
  },
  props: ['accessToken', 'refreshToken', 'renewTokens', 'logout'],
  computed: { 
    getFloors() {
      if (this.buildings.length > 0) {
        let buildingsArray = [];
        let floorsArray = [];
        this.buildings.forEach(b => {
          floorsArray = [... b.floors.map(f => {
            return {'value': f.id, 'text': b.name + ', ' +f.name};
          })];
          console.log(floorsArray);
          buildingsArray = buildingsArray.concat(floorsArray);
        });
        console.log(buildingsArray);
        return buildingsArray;
      }
      return [];
    },
    getCurrentFloor() {
      if (this.buildings.length > 0) {
        let floor = {};
        this.buildings.forEach(b=> {
          let curFloor = b.floors.find(f => f.id === this.currentFloorId);
          if (curFloor !== undefined) {
            floor = curFloor;
          }
        });
        return floor;
      }
      return [];
    },
    getCurrentSpace() {
      if (this.getCurrentFloor.spaces) {
        let space = this.getCurrentFloor.spaces.find(s => s.id === this.currentSpaceId);
        if (space === undefined){
          return null;
        }
        return space;	
      }
      return null;
    }
  },
  methods: {
    setCurrentSpace(spaceId) {
      this.currentSpaceId = spaceId;
    },
    getSpaceColor(space) {
      if(space.occupied) {
        if(this.currentSpaceId == space.id || !this.currentSpaceId) {
          if (space.latest_rent_history && 
              space.latest_rent_history.tenant && 
              space.latest_rent_history.tenant.map_color !== "#000000") {
            return space.latest_rent_history.tenant.map_color;
          }
          return space.map_color;
        } else {
          return '#000';
        }
      } else {
        return '#000';
      }
    },
    removeCurrentSpace() {
      setTimeout(() => {
        this.setCurrentSpace(null)
      }, 200);
    },
    logOut() {
      if(typeof this.logout === 'function'){
        this.logout();
      }
    },
    initApiData() {
      fetch(`https://map.izone.ua/api/building/`, {
        method: "get",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${this.accessToken}`
        }
      }).then(response=>response.json()).then(json=> {
        if (json.code === "token_not_valid") {
          if(typeof this.renewTokens === 'function'){
            this.renewTokens(this.refreshToken);
          }
        } else {
          this.buildings = json;
          this.currentFloorId = this.buildings[0].floors[0].id;
        }
      });
    }
  },
  mounted() {
    this.initApiData();
  },
  watch: {
    currentFloorId() {
      localStorage.setItem('currentFloorId', this.currentFloorId);
    }
  }
};
</script>